import { useTranslation } from "react-i18next";
import { DateSelectors } from "../../components/admin/Common/DateSelectors";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getOrder,
  getOrders,
} from "../../redux/slices/admin.slices/orders.slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { OrderCards } from "../../components/admin/ProductOrders/OrderCards";
import { OrderCard } from "../../components/admin/ProductOrders/OrderCard";
import { ProductOrder } from "../../types/admin/productOrder.types";
import { NoItemsMessage } from "../../components/admin/Common/NoItemsMessage";

export const ProductOrders = () => {
  const today = new Date();
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState<Date | null>(today);
  const [toDate, setToDate] = useState<Date | null>(today);
  const { selectedCity } = useSelector((state: RootState) => state.city);
  const { productOrders } = useSelector((state: RootState) => state.orders);

  const openOrder = (id: string) => {
    navigate(`/admin/orders/${id}`, {
      preventScrollReset: true,
    });
  };

  const closeOrder = () => {
    navigate("/admin/orders", {
      preventScrollReset: true,
    });
  };

  const fetchProductOrders = () => {
    dispatch(
      getOrders({
        fromDate: fromDate ? fromDate.toISOString().split("T")[0] : undefined,
        toDate: toDate ? toDate.toISOString().split("T")[0] : undefined,
        city:
          selectedCity?.city === "All cities" ? undefined : selectedCity?.city,
      }) as any,
    );
  };

  useEffect(() => {
    if (id) {
      if (!productOrders?.find((b) => b?._id === id)?.product?._id) {
        dispatch(getOrder({ ids: [id] }) as any);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchProductOrders();
  }, [fromDate, toDate, selectedCity]);

  return (
    <div className="p-6 relative">
      <h1 className="text-2xl font-bold mb-6">{t("Product Orders")}</h1>

      <DateSelectors
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        handleRefresh={fetchProductOrders}
      />

      {productOrders && productOrders?.length > 0 ? (
        <OrderCards
          orders={productOrders}
          setSelectedProductOrderId={openOrder}
        />
      ) : (
        <NoItemsMessage
          title="No orders found"
          message="No product orders for the selected date and location"
        />
      )}

      {id && productOrders?.length > 0 && (
        <OrderCard
          order={productOrders?.find((o) => o._id === id) as ProductOrder}
          onClose={closeOrder}
        />
      )}
    </div>
  );
};
